<button
  data-test="vsQhXdOD"
  class="button button_link"
  [mdPopover]="actionsDropdown"
  #actionsPopover="mdPopover"
>
  <span data-test="mkGK42vJ">Action</span>
  <span data-test="sBmQAw3z" class="button__icon button__icon_right">
    <i data-test="OAJEpFlC" class="material-icons md-14" style="margin: 0 -4px">
      keyboard_arrow_down
    </i>
  </span>
</button>
<div
  data-test="2ouTkOdR"
  #actionsDropdown
  class="dropdown dropdown_bottom-right dropdown_arrow"
  id="dd-action"
  style="right: -8px"
>
  <div data-test="I3FRp0I-" class="dropdown__wrap">
    <ul
      data-test="EVwUDOi0"
      class="dropdown__menu"
      (click)="actionsPopover.togglePopup(false)"
    >
      <li data-test="kqnE6xXU" *ngFor="let item of items" class="dropdown__menu-item">
        <a
          data-test="oZ_-Vs-o"
          class="dropdown__menu-link"
          (click)="itemClick.emit(item.id)"
        >
          <div data-test="9xjgFTfm" class="icon">
            <svg
              data-test="C8ICjPCi"
              [class]="'icon__icon-check' + item.icon"
              width="14px"
              height="14px"
            >
              <use [attr.xlink:href]="'#icon-' + item.icon"></use>
            </svg>
          </div>
          {{ item.name }}
        </a>
      </li>
    </ul>
  </div>
</div>
